
import { Component, Vue } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import bindEmail from './bindEmail.vue'
import wechatBind from './wechatBind.vue'
import mobileBind from './mobileBind.vue'
import passwordBind from './passwordBind.vue'
@Component({
  components: {
    bindEmail,
    wechatBind,
    mobileBind,
    passwordBind,
  },
})
export default class AccoundNumberInfo extends Vue {
  private bindRouter: any = '';
  private open:any = "0";
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  mounted() {
    this.bindRouter = this.$route.query.bind;
    this.open = this.$route.query.open as string;
  }
}
